export const selector = '#content'

export default (
    el = null
) => {
    if (!el
            || document.body.classList.contains('.wp-admin'))
        return el

    console.groupCollapsed('Discoverables')

    const offcanvasId = 'discoverable-offcanvas'

    const offcanvas = document
        .querySelector(`#${offcanvasId}`)

    const offcanvasToggle = document
        .querySelector(`[data-bs-target='#${offcanvasId}']`)

    const offcanvasHeader = offcanvas
        && offcanvas.querySelector('.offcanvas-header')

    const offcanvasBody = offcanvas
        && offcanvas.querySelector('.offcanvas-body')

    const backBtn = offcanvasHeader
        .querySelector('.discoverable-back')

    const discoverableSectionCss = 'discoverable-section'

    const getLinks = () => Array.from(document
        .querySelectorAll("a[href^='/discoverable/'], a[href^='/artwork/']"))
        .filter(a => a.href.match(/^(https?:\/\/[^/]+)\/([^/]+)\/([^/]+)(\/.*)?$/))

    const countDiscoverables = () => {
        if (!offcanvasBody)
            return

        const sections = offcanvasBody
            ?.querySelectorAll(`.${discoverableSectionCss}`)

        offcanvas.setAttribute('data-discoverables-count',
            sections.length)
    }

    const onGoBack = () => {
        const allSections = offcanvasBody
            ?.querySelectorAll(`.${discoverableSectionCss}`)

        const totalSections = allSections.length

        if (!allSections
                || totalSections < 2)
            return

        allSections[totalSections - 1]
            .remove()

        countDiscoverables()
    }

    const onLinkClick = async (e) => {
        if (!offcanvas
                || !offcanvasBody
                || !offcanvasToggle
                || (e || {}).ctrlKey)
            return

        e.preventDefault()

        const fromOffcanvas = e?.target
            .closest('.offcanvas')

        if (!fromOffcanvas) {
            offcanvasBody.innerHTML = ''
            offcanvasToggle.click()
        }

        const discoverableHTML = await window.fetch(e.target.href)
            .then(res => res.text())
            .catch(err => console.warn(err))

        if (!discoverableHTML)
            return console.log('Handle empty fetch')

        const parser = new window.DOMParser()

        const discoverable = parser
            .parseFromString(discoverableHTML, 'text/html')

        const discoverableMain = discoverable
            .querySelector('main')

        if (!discoverableMain)
            return

        const section = document.createElement('div')
        section.setAttribute('class', discoverableSectionCss)

        offcanvasBody.appendChild(section)

        Array.from(discoverableMain.children || [])
            .forEach(child => section.appendChild(child))

        if (backBtn)
            backBtn.addEventListener('click',
                onGoBack)

        offcanvas.scrollTo(0, 0)

        countDiscoverables()

        onPageLoad()
    }

    const onPageLoad = (e) => {
        getLinks()
            .filter(link => !link._offcanvasListener)
            .forEach(link => {
                link._offcanvasListener = true

                link.addEventListener('click', onLinkClick)
            })
    }

    window
        .addEventListener('load', () => {
            const href = decodeURI(window.location.href)
                .replace(/(\[\d+\]=)/g, '[]=')
                .replace(/(\?|&)doing_wp_cron=.+$/, '')

            if (!('history' in window)
                    || window.location.href === href)
                return

            window.history.replaceState(null, '', href)
        })

    if (import.meta.hot)
        import.meta.hot
            .on('vite:beforeUpdate', () => {
                getLinks()
                    .forEach(link => {
                        link._offcanvasListener = false

                        link.removeEventListener('click', onLinkClick)
                    })

                backBtn.removeEventListener('click',
                    onGoBack)
            })

    onPageLoad()

    console.log(el)

    console.groupEnd()

    return el
}
